import { useState } from "react";
import { Box, Button, Fade, Hidden, Modal } from "@material-ui/core";
import Slider from "react-slick";
import CheckIcon from "@material-ui/icons/Check";
import RemoveIcon from "@material-ui/icons/Remove";
import AddIcon from "@material-ui/icons/Add";
import ClearIcon from "@material-ui/icons/Clear";

import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import { quateAddonQuantityValue } from "../../../../app/utils";
import { QuoteLineItem } from "../../../../api/Quote/QuoteLineItem";
import { useAddOnItemDetailsStyles } from "./AddOnItemDetails.styles";
import { PriceFormat } from "../../../../components/typography/PriceFormat";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  borderRadius: "4px",
  boxShadow: 24,
  p: 8
};

export const AddOnItemDetails = ({
  item,
  onChangeQuantity,
  onAddAddon
}: {
  item: QuoteLineItem;
  onChangeQuantity: (addon: QuoteLineItem, quantity: number) => void;
  onAddAddon: (addon: QuoteLineItem) => void;
}) => {
  const { isMoreThanSm } = useBreakpoint();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const classes = useAddOnItemDetailsStyles();

  const settings = {
    dots: true,
    fade: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  return (
    <>
      <Button onClick={handleOpen} className={classes.moreDetails}>
        More Details
      </Button>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
      >
        <Fade in={open}>
          <Box sx={style} flexDirection={isMoreThanSm ? "row" : "column"} className={classes.container}>
            <Box position={"absolute"} top={isMoreThanSm ? "10px" : "10px"} right={isMoreThanSm ? "10px" : "5px"}>
              <Button onClick={handleClose}>
                <ClearIcon />
              </Button>
            </Box>
            <Hidden smUp>
              <Box className={classes.title}>{item.name}</Box>
            </Hidden>
            <Box width={156} height={217} mt={1} ml={1}>
              <Slider {...settings}>
                <Box>
                  <img alt={item.name} src={item.imageUrl} width={100} height={150} className={classes.img} />
                </Box>
              </Slider>
            </Box>
            <Box ml={isMoreThanSm ? 10 : 0}>
              <Hidden smDown>
                <Box className={classes.title}>{item.name}</Box>
              </Hidden>
              <Box className={classes.subTitle}> {item.highLevelDescription}</Box>
              <Box className={classes.price}>
                <PriceFormat value={quateAddonQuantityValue(item)} />
              </Box>
              <Box display="flex" mb={4}>
                <Box className={classes.showQuantity}>
                  <button
                    onClick={() => {
                      onChangeQuantity(item, item.quantity - 1);
                    }}
                    disabled={item.quantity === 1}
                    className={classes.button}
                  >
                    <RemoveIcon />
                  </button>
                  <span>{item.quantity}</span>
                  <button
                    className={classes.button}
                    disabled={item.quantity === item.maxQuantity}
                    onClick={() => {
                      onChangeQuantity(item, item.quantity + 1);
                    }}
                  >
                    <AddIcon />
                  </button>
                </Box>
                <Button
                  className={classes.add}
                  onClick={() => {
                    onAddAddon(item);
                    setOpen(false);
                  }}
                  disabled={item.selected}
                >
                  {item.selected && <CheckIcon />}
                  {item.selected ? "Added" : "Add"}
                </Button>
              </Box>
              <Box mb={2}>Highlights</Box>
              <Box>{item.description}</Box>
              <Box ml={-3}>
                <ul>
                  {item.highlights?.map((highlight, idx) => (
                    <li key={idx}>{highlight}</li>
                  ))}
                </ul>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};
